module.exports = __webpack_public_path__ + "img/SRB.1943f023.svg";